import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { IoCash, IoCashOutline } from "react-icons/io5";
import Select from "react-select";
import {
  Button,
  Col,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import {
  applyClassToCharacters,
  customOption,
  getStringFromJSX,
  isUrdu,
} from "../../../../constants/const";
import { GetLanguageString } from "../../../helper/Components";
import { GetCustomStyles } from "../../../helper/Method";

const AmanatToCashAccountForm = ({
  setValues,
  values,
  errors,
  fundAccountBalances,
  handleInputChange,
  handleDateChange,
  handleBankAccountChange,
  isEdit = false,
  selectedBankAccount,
  unitBankAccounts,
  handleAddNew,
  showRowsTable,
  showExtraFile,
  handleChangeTableData,
  rows,
  addRow,
  removeRow,
  disableFileForFuture = false,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <style>{`
        .balance-card-hover:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.08) !important;
        }
        @keyframes bounce-dots {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
        .bouncing-loader {
          display: flex;
          align-items: center;
          height: 24px;
          margin-top: 4px;
        }
        .bouncing-loader span {
          width: 8px;
          height: 8px;
          margin: 0 3px;
          background-color: currentColor;
          border-radius: 50%;
          display: inline-block;
          animation: bounce-dots 1.4s infinite ease-in-out both;
        }
        .bouncing-loader span:nth-child(1) { animation-delay: -0.32s; }
        .bouncing-loader span:nth-child(2) { animation-delay: -0.16s; }
      `}</style>
      {/* BALANCE CARDS */}
      <Row style={{ marginBottom: "20px" }}>
        {/* Amanat Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <div
            style={{
              padding: "12px 20px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e7eaec",
              borderLeft: "5px solid #3b82f6",
              boxShadow: "0 4px 6px rgba(0,0,0,0.03)",
              transition: "transform 0.2s, box-shadow 0.2s",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            className="balance-card-hover"
          >
            <div>
              <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                <GetLanguageString props="transactions_amanat_account_balance" />
              </div>
              <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#3b82f6" }}>
                {!fundAccountBalances || fundAccountBalances.amanatAccountBalance === undefined ? (
                  <div className="bouncing-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                ) : (
                  new Intl.NumberFormat().format(fundAccountBalances.amanatAccountBalance)
                )}
              </div>
            </div>
            <div style={{ backgroundColor: "#eff6ff", padding: "10px", borderRadius: "50%" }}>
              <IoCash style={{ color: "#3b82f6", fontSize: "24px" }} />
            </div>
          </div>
        </Col>

        {/* Cash Account Balance */}
        <Col xs="6" md="6" xl="6" className="mb-3">
          <div
            style={{
              padding: "12px 20px",
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              border: "1px solid #e7eaec",
              borderLeft: "5px solid #1ab394",
              boxShadow: "0 4px 6px rgba(0,0,0,0.03)",
              transition: "transform 0.2s, box-shadow 0.2s",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
            className="balance-card-hover"
          >
            <div>
              <div style={{ fontSize: "11px", textTransform: "uppercase", color: "#888888", fontWeight: "600", letterSpacing: "0.5px" }}>
                <GetLanguageString props="cash_account_balance" />
              </div>
              <div style={{ fontSize: "24px", fontWeight: "700", marginTop: "4px", color: "#1ab394" }}>
                {!fundAccountBalances || fundAccountBalances.cashAccountBalance === undefined ? (
                  <div className="bouncing-loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                ) : (
                  new Intl.NumberFormat().format(fundAccountBalances.cashAccountBalance)
                )}
              </div>
            </div>
            <div style={{ backgroundColor: "#e8f7f4", padding: "10px", borderRadius: "50%" }}>
              <IoCashOutline style={{ color: "#1ab394", fontSize: "26px" }} />
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        {/* Transfer Amount */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="funds_add_fund_amount" />
            </Label>
            <Input
              type="text"
              name="transferAmount"
              placeholder={t("funds_add_fund_amount")}
              value={values.transferAmount}
              onChange={(e) => {
                const val = e.target.value;
                if (/^\d*$/.test(val)) {
                  handleInputChange({
                    target: { name: "transferAmount", value: val },
                  });
                }
              }}
              invalid={!!errors.transferAmount}
            />
            {errors.transferAmount && (
              <FormFeedback>
                <h4>{errors.transferAmount}</h4>
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        {/* Deposit Date */}
        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="dashboard_event_page_date" />
            </Label>
            <DatePicker
              selected={values.requestDate}
              onChange={handleDateChange}
              className={`form-control ${errors.requestDate ? "is-invalid" : ""
                }`}
              dateFormat="dd/MM/yyyy"
            />
            {errors.requestDate && (
              <div className="invalid-feedback d-block">
                <h4>{errors.requestDate}</h4>
              </div>
            )}
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="fund_bank_account" />
            </Label>

            <div style={{ display: "flex", gap: "8px" }}>
              {/* Select */}
              <div style={{ flex: 1 }}>
                <Select
                  components={{
                    Option: customOption,
                  }}
                  options={unitBankAccounts}
                  value={{
                    value: selectedBankAccount?.value,
                    label: selectedBankAccount?.label
                      ? applyClassToCharacters(selectedBankAccount?.label, "ur")
                      : "",
                  }}
                  onChange={handleBankAccountChange}
                  placeholder="Select bank account"
                  classNamePrefix="select"
                />
              </div>

              {/* Small Button */}
              <Button
                color="primary"
                size="sm"
                onClick={() => handleAddNew(true)}
                style={{
                  height: "38px", // matches Select height
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 12px", // small compact button
                }}
              >
                <FaPlus
                  color="#f7f7f7ff"
                  size={11}
                  style={{ marginRight: 5, marginBottom: 1 }}
                />
                {t("tutorial_add_category")}
              </Button>
            </div>
          </FormGroup>
        </Col>

        {/* Memo */}
        <Col md={isEdit ? "6" : "6"}>
          <FormGroup>
            <Label className="col-form-label">
              <GetLanguageString props="transactions_memo" />
            </Label>
            <Input
              type="textarea"
              name="memo"
              placeholder="Memo"
              className={isUrdu(values?.memo) ? "ur " : ""}
              value={
                values?.memo
                  ? getStringFromJSX(applyClassToCharacters(values?.memo, "ur"))
                  : ""
              }
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        {showExtraFile && (
          <Col md="6">
            <FormGroup>
              <Label className="col-form-label">
                <GetLanguageString props="transactions_shura_approval_attachment" />
              </Label>
              <Input
                type="file"
                name="extraFile"
                onChange={(e) =>
                  setValues((prev) => ({
                    ...prev,
                    extraFile: e.target.files[0],
                  }))
                }
                className={`form-control ${errors.extraFile ? "is-invalid" : ""
                  }`}
              />
              {errors.extraFile && (
                <div className="invalid-feedback d-block">
                  <h4>{errors.extraFile}</h4>
                </div>
              )}
            </FormGroup>
          </Col>
        )}
      </Row>

      {showRowsTable && (
        <>
          <hr />
          <Row>
            <div className="ibox">
              <div className="ibox-title">
                <h5>{<GetLanguageString props="sidebar_funds_expenses" />}</h5>
                <Button
                  className={GetCustomStyles().btn_style}
                  color="white"
                  size="xs"
                  onClick={addRow}
                >
                  <FaPlus
                    color="#18A689"
                    size={13}
                    style={{ marginRight: 5, marginBottom: 1 }}
                  />
                  {<GetLanguageString props="tutorial_add_category" />}
                </Button>
              </div>

              <div className="ibox-content">
                <Row>
                  <Col md="12">
                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>
                            {
                              <GetLanguageString props="sidebar_funds_expense" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="funds_add_fund_amount" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="dashboard_event_page_date" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="transactions_expense_type" />
                            }
                          </th>
                          <th>
                            {
                              <GetLanguageString props="transactions_expense_receipt" />
                            }
                          </th>
                          <th style={{ width: "40px" }}></th>
                        </tr>
                      </thead>

                      <tbody>
                        {rows.map((row, i) => (
                          <tr key={i}>
                            <td>
                              <Input
                                type="text"
                                value={row.description}
                                onChange={(e) =>
                                  handleChangeTableData(
                                    i,
                                    "description",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter description"
                                className={
                                  errors[`row_${i}_description`]
                                    ? "is-invalid"
                                    : ""
                                }
                              />
                              {errors[`row_${i}_description`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_description`]}</h4>
                                </div>
                              )}
                            </td>

                            <td>
                              <Input
                                type="text"
                                value={row.amount}
                                onChange={(e) => {
                                  const val = e.target.value;

                                  // Allow only digits (empty allowed)
                                  if (/^\d*$/.test(val)) {
                                    handleChangeTableData(i, "amount", val);
                                  }
                                }}
                                placeholder="0"
                                className={
                                  errors[`row_${i}_amount`] ? "is-invalid" : ""
                                }
                              />

                              {errors[`row_${i}_amount`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_amount`]}</h4>
                                </div>
                              )}
                            </td>

                            <td>
                              <DatePicker
                                selected={
                                  row.date ? new Date(row.date) : new Date()
                                }
                                onChange={(date) =>
                                  handleChangeTableData(i, "date", date)
                                }
                                className="form-control"
                                dateFormat="dd/MM/yyyy"
                                minDate={
                                  row.expenseType === "future"
                                    ? new Date()
                                    : null
                                }
                                maxDate={
                                  row.expenseType === "past" ? new Date() : null
                                }
                              />
                            </td>
                            <td style={{ verticalAlign: "middle" }}>
                              <div
                                className="d-flex justify-content-center align-items-center"
                                style={{ gap: "25px", height: "100%" }}
                              >
                                {/* Past */}
                                <label
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Input
                                    type="radio"
                                    name={`expenseType_${i}`}
                                    value="past"
                                    checked={row.expenseType === "past"}
                                    onChange={(e) =>
                                      handleChangeTableData(
                                        i,
                                        "expenseType",
                                        e.target.value
                                      )
                                    }
                                    style={{ marginRight: "6px" }}
                                  />
                                  <span>
                                    {
                                      <GetLanguageString props="transactions_past" />
                                    }
                                  </span>
                                </label>

                                {/* Future */}
                                <label
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ cursor: "pointer" }}
                                >
                                  <Input
                                    type="radio"
                                    name={`expenseType_${i}`}
                                    value="future"
                                    checked={row.expenseType === "future"}
                                    onChange={(e) =>
                                      handleChangeTableData(
                                        i,
                                        "expenseType",
                                        e.target.value
                                      )
                                    }
                                    style={{ marginRight: "6px" }}
                                  />
                                  <span>
                                    {
                                      <GetLanguageString props="transactions_future" />
                                    }
                                  </span>
                                </label>
                              </div>
                            </td>

                            <td>
                              <Input
                                type="file"
                                onChange={(e) =>
                                  handleChangeTableData(
                                    i,
                                    "file",
                                    e.target.files[0]
                                  )
                                }
                                disabled={
                                  disableFileForFuture &&
                                  row.expenseType === "future"
                                }
                                className={
                                  errors[`row_${i}_file`] ? "is-invalid" : ""
                                }
                              />

                              {errors[`row_${i}_file`] && (
                                <div className="invalid-feedback d-block">
                                  <h4>{errors[`row_${i}_file`]}</h4>
                                </div>
                              )}
                            </td>

                            {/* <td>
                              <Input
                                type="file"
                                onChange={(e) =>
                                  handleChangeTableData(i, "file", e.target.files[0])
                                }
                              />
                            </td> */}
                            <td style={{ width: "40px", textAlign: "center" }}>
                              {rows.length > 1 && (
                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => removeRow(i)}
                                  style={{ padding: "5px 8px" }}
                                >
                                  <FaTrashAlt />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </>
      )}
    </>
  );
};
export default AmanatToCashAccountForm;
